import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import IMetadata from '../../../../_interfaces/IMetadata';
import IMetadataOption from '../../../../_interfaces/IMetadataOption';
import { ErrorsService } from '../../../../_services/errors/errors.service';
import { PatientsMetadataService } from '../../../../_services/patients/patients-metadata.service';
import { SessionService } from '../../../../_services/session/session.service';
import { BaseComponent } from '../../../../components/base/base.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  standalone: true,
  selector: 'app-create-metadata-option',
  templateUrl: './create-metadata-option.component.html',
  styleUrls: ['./create-metadata-option.component.scss'],
  imports: [
    FormsModule,
    ButtonModule,
    TranslatePipe,

    CommonModule,
    InputTextModule,
    RadioButtonModule,
  ],
})
export class CreateMetadataOptionComponent
  extends BaseComponent
  implements OnInit
{
  public defaultOption: IMetadataOption;
  public metadata: IMetadata;
  constructor(
    public patientMetadataService: PatientsMetadataService,
    public messageService: MessageService,
    public errorsService: ErrorsService,
    public translate: TranslateService,
    public session: SessionService
  ) {
    super(session);
  }

  delete(indice) {
    this.metadata.options.splice(indice, 1);
  }

  addOption() {
    this.metadata.options.push({
      name: undefined,
      default: false,
    });
  }

  clear() {
    this.metadata = {
      customers_id: this.customers_id,
      metadata_types_id: 1,
      name: undefined,
      default: undefined,
      options: [],
    };
  }

  save() {
    this.metadata.options.forEach((option) => {
      if (this.defaultOption && option.name === this.defaultOption.name) {
        option.default = true;
      }
    });
    this.patientMetadataService
      .create(this.customers_id, this.metadata)
      .subscribe({
        next: () => {
          this.clear();
          this.messageService.add({
            severity: 'success',
            detail: this.translate.instant('MESSAGES.METADATA.CREATE.DETAIL'),
            summary: this.translate.instant('MESSAGES.METADATA.CREATE.SUMMARY'),
          });
        },
        error: (error) => {
          const code = this.errorsService.getMessageFromMetadataError(error);
          this.messageService.add({
            summary: this.translate.instant('MESSAGES.METADATA.ERROR.SUMMARY'),
            detail: this.translate.instant(`MESSAGES.METADATA.ERROR.${code}`),
            severity: 'error',
          });
        },
      });
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.clear();
  }
}
